import { Row, Col } from "react-bootstrap";
import Praise from "./Praise";
import "./ValuesList.css";

function PraisesList({ praises, url, userId, handleShow, language }) {
  return (
    <Col className="praises-list">
      <Row>
        {praises.map((element) => (
          <Praise
            key={element._id}
            id={element._id}
            title={element.title}
            receiverName={element.receiverName}
            receiverProfilePicture={element.receiverProfilePicture}
            senderId={element.senderId}
            senderName={element.senderName}
            senderProfilePicture={element.senderProfilePicture}
            message={element.message}
            values={element.values}
            createdAt={element.createdAt}
            userId={userId}
            handleShow={handleShow}
            language={language}
          />
        ))}
      </Row>
    </Col>
  );
}

export default PraisesList;
